<template>
  <svgImage :name="`pricing-discount-${normalizedLang}`" />
</template>

<script>
import svgImage from '../../common/VueComponents/VueIcon/vgpSvgImage.vue';

export default ({
  components: {
    svgImage,
  },
  data() {
    return {
      lang: window.lang.lang,
    };
  },
  computed: {
    normalizedLang() {
      const supportedLangsForDiscountSvgFullIcon = ['en', 'ru', 'de', 'pt', 'es', 'kr'];

      return supportedLangsForDiscountSvgFullIcon.includes(this.lang) ? this.lang : 'universal';
    },
  },
  methods: {
  },
});
</script>
